import { render, staticRenderFns } from "./AssignRequestToDriver.vue?vue&type=template&id=731205b6&"
import script from "./AssignRequestToDriver.vue?vue&type=script&lang=js&"
export * from "./AssignRequestToDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports